<template>
    <div class="compliance-plan-badge">
        <b-badge :variant="badgeVariant">
            {{ planLabel }}
        </b-badge>
        <label class="compliance-plan-badge__exemption-status mt-2"
               v-if="exemptionStatus">
            {{ exemptionStatusLabel }}
        </label>
    </div>
</template>

<script>
import * as _ from 'lodash'
import Exemption from '@/models/Exemption'

const actions = [
    { value: 'REPOWER', title: 'Repower' },
    { value: 'RETROFIT', title: 'Retrofit' },
    { value: 'FUEL', title: 'Alternative Fuel' },
    { value: 'RENTAL', title: 'Rent Equipment' },
    { value: 'EXEMPTION', title: 'Request Exemption' },
]

export default {
    name: 'CompliancePlanBadge',
    props: {
        equipment: Object
    },
    computed: {
        action () {
            const plan = this.equipment.compliance_plan
            return _.find(actions, (a) => {
                return a.value === plan
            })
        },
        planLabel () {
            return (this.action ? this.action.title : 'None')
        },
        exemptionStatus () {
            if (this.equipment.compliance_plan === 'EXEMPTION') {
                if (this.equipment.exemptions.length) {
                    const exemption = _.last(this.equipment.exemptions)
                    return exemption.status
                }
            }
            return null
        },
        exemptionStatusLabel () {
            if (this.equipment.compliance_plan === 'EXEMPTION') {
                const status = this.exemptionStatus
                if (status) {
                    return 'Status: ' + Exemption.getStatusLabel(status)
                } else {
                    return 'Status: Not Requested'
                }
            } else {
                return null
            }
        },
        badgeVariant () {
            const status = this.exemptionStatus
            if (status) {
                if (status === 'GRANTED') {
                    return 'success'
                } else if (status === 'DENIED') {
                    return 'danger'
                } else {
                    return 'warning'
                }
            } else {
                return (this.action ? 'warning' : 'danger')
            }
        }
    }
}
</script>

<style lang="scss">
.compliance-plan-badge {
    display: inline-block;
}

.compliance-plan-badge__exemption-status {
    display: block;
    text-align: center;
    color: #ddd;
    font-weight: bold;
    letter-spacing: 1.5px;
}
</style>
